export function IntersectionObserver(...args) {
  return window?.IntersectionObserver ? new window.IntersectionObserver(...args)
    : { observe() {}, unobserve() {}, disconnect() {} };
}
